import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {DashboardSelectorController} from 'common/report/controllers/dashboard-selector-controller';
import {ButtonTheme} from 'common/components/button/constants';

import css from './index.styl?inline';
import {template} from './template';

interface BoardsSaveButtonAttrs {
  'selected-dashboard-id': number;
  'user-id': number;
  disabled: boolean;
  tooltip?: string;
  theme: ButtonTheme;
  label?: string;
  'align-right'?: boolean;
  'search-placeholder': string;
}

interface BoardsSaveButtonJsxProps {
  attrs?: BoardsSaveButtonAttrs;
  props?: {
    dashboardController: DashboardSelectorController;
  };
  on?: {
    save: (ev?: CustomEvent) => void;
  };
}

interface BoardsSaveButtonState {
  isOpen: boolean;
  isLoading: boolean;
}

export class BoardsSaveButton extends Component<BoardsSaveButtonState, BoardsSaveButtonAttrs> {
  private _dashboardController: DashboardSelectorController;

  static get attrsSchema(): AttrsSchema<BoardsSaveButtonAttrs> {
    return {
      ...super.attrsSchema,
      'selected-dashboard-id': `number`,
      'user-id': `number`,
      disabled: `boolean`,
      'align-right': `boolean`,
      theme: {type: `string`, default: ButtonTheme.Tertiary},
      label: {type: `string`, default: `Save`},
      tooltip: `string`,
      'search-placeholder': `string`,
    };
  }

  get config() {
    return {
      defaultState: {
        isOpen: false,
        isLoading: false,
      },
      useShadowDom: true,
      css,
      template,
      helpers: {
        handleSaveButtonClicked: () => {
          if (this.attr(`selected-dashboard-id`)) {
            this.dispatchEvent(new CustomEvent(`save`, {detail: {dashboardId: this.attr(`selected-dashboard-id`)}}));
          } else {
            this.update({isOpen: true});
          }
        },
        handleDashboardSelected: (ev) => {
          this.update({isOpen: false});
          this.dispatchEvent(new CustomEvent(`save`, {detail: {dashboardId: ev.detail.id}}));
          ev.preventDefault();
        },
        handleMenuChanged: (ev) => {
          this.update({isOpen: ev.detail.state === `open`});
          this.dispatchEvent(new CustomEvent(`menuchange`, {detail: ev.detail}));
        },
      },
    };
  }

  set dashboardController(controller: DashboardSelectorController) {
    controller.getDashboards();
    this._dashboardController = controller;
    this.update();
  }
  get dashboardController() {
    return this._dashboardController;
  }
}

export const BoardsSaveButtonEl = defineAndMakeJsxFactory<BoardsSaveButtonJsxProps>(
  `mp-boards-save-button`,
  BoardsSaveButton,
);
